import { SvgIcon, SvgIconProps } from '@mui/material'
import { FC } from 'react'

interface AddressPinIconProps extends SvgIconProps {
  // fillColor?: string;
}

export const AddressPinIcon: FC<AddressPinIconProps> = ({ fill, ...props }) => {
  return (
    <SvgIcon
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        id="Union"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20 2.08325C15.6277 2.08325 12.0833 5.62766 12.0833 9.99992C12.0833 13.9468 14.9717 17.2191 18.75 17.8185V28.3333C18.75 29.0236 19.3096 29.5833 20 29.5833C20.6904 29.5833 21.25 29.0236 21.25 28.3333V17.8185C25.0283 17.2191 27.9167 13.9468 27.9167 9.99992C27.9167 5.62766 24.3723 2.08325 20 2.08325ZM13.6029 23.5801C14.277 23.4312 14.7028 22.7641 14.5539 22.0899C14.405 21.4158 13.7379 20.9901 13.0637 21.139C10.4924 21.7069 8.23921 22.5966 6.59596 23.7511C4.97493 24.8899 3.75 26.4398 3.75 28.3332C3.75 29.6604 4.36041 30.8307 5.27328 31.7899C6.18002 32.7427 7.43302 33.5439 8.88573 34.1895C11.7943 35.4822 15.7248 36.2499 20 36.2499C24.2752 36.2499 28.2057 35.4822 31.1143 34.1895C32.567 33.5439 33.82 32.7427 34.7267 31.7899C35.6396 30.8307 36.25 29.6604 36.25 28.3332C36.25 26.4398 35.0251 24.8899 33.404 23.7511C31.7608 22.5966 29.5076 21.7069 26.9363 21.139C26.2621 20.9901 25.595 21.4158 25.4461 22.0899C25.2972 22.7641 25.723 23.4312 26.3971 23.5801C28.7648 24.1031 30.6783 24.8914 31.9669 25.7967C33.2778 26.7176 33.75 27.6091 33.75 28.3332C33.75 28.847 33.5209 29.4305 32.9157 30.0665C32.3044 30.7089 31.3607 31.3442 30.0989 31.905C27.5786 33.0252 24.0091 33.7499 20 33.7499C15.9909 33.7499 12.4214 33.0252 9.90107 31.905C8.63931 31.3442 7.69561 30.7089 7.08427 30.0665C6.47906 29.4305 6.25 28.847 6.25 28.3332C6.25 27.6091 6.7222 26.7176 8.03308 25.7967C9.32173 24.8914 11.2352 24.1031 13.6029 23.5801Z"
        fill={fill}
        stroke={fill}
      />
    </SvgIcon>
  )
}
